import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"

// Estilos y assets de la landing importados desde la carpeta PHP original
import "./WaveSaleslandingpage/css/style.css"
import "./WaveSaleslandingpage/css/aos.css"

import logo from "./WaveSaleslandingpage/img/logo.png"
import landingGif from "../assets/landing_presentacion.gif"
import beneficio1 from "./WaveSaleslandingpage/img/beneficio1.png"
import beneficio2 from "./WaveSaleslandingpage/img/beneficio2.png"
import beneficio3 from "./WaveSaleslandingpage/img/beneficio3.png"
import FloatingWhatsApp from "../components/FloatingWhatsApp"
import { markPaid, isBasicBlocked } from "../utils/payments"
import api from "../api"



function WaveSalesLanding() {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || "dark"
  })
  // Toggle de menú móvil simple (sin dependencias externas)
  useEffect(() => {
    const menuToggle = document.querySelector(".menu-toggle")
    const menu = document.querySelector("nav ul.menu")
    const onClick = () => menu && menu.classList.toggle("show")
    if (menuToggle) menuToggle.addEventListener("click", onClick)
    return () => {
      if (menuToggle) menuToggle.removeEventListener("click", onClick)
    }
  }, [])
  useEffect(() => {
    document.body.classList.toggle("light", theme === "light")
    localStorage.setItem("theme", theme)
  }, [theme])
  const toggleTheme = () => {
    setTheme(prev => (prev === "dark" ? "light" : "dark"))
  }

  // PayPal subscription buttons (Básico/Pro/Enterprise) con estados independientes
  const paypalLoadedRef = useRef(false);
  // NOTA: Este archivo es .jsx (no .tsx).
  const [paypalStatus, setPaypalStatus] = useState('idle');      // Básico
  const [paypalError, setPaypalError] = useState('');
  const [paypalStatusPro, setPaypalStatusPro] = useState('idle'); // Pro
  const [paypalErrorPro, setPaypalErrorPro] = useState('');
  const [paypalStatusEnt, setPaypalStatusEnt] = useState('idle'); // Enterprise
  const [paypalErrorEnt, setPaypalErrorEnt] = useState('');
  const [basicDisabled, setBasicDisabled] = useState(false);

  const PLAN_BASIC_ID = 'P-0JM303090H911440NNEHHBDQ'; // (ya no se usa en Básico, se cambia a Hosted Buttons)
  const PLAN_PRO_ID   = 'P-0AL74437SD0607350NEKAA2A';
  const PLAN_ENT_ID   = 'P-22615101DU119082JNEKABSI';

  const CID_BASIC = 'paypal-container-UXVU9HSN2NWCE';
  const CID_PRO   = 'paypal-button-container-P-0AL74437SD0607350NEKAA2A';
  const CID_ENT   = 'paypal-button-container-P-22615101DU119082JNEKABSI';
  const HOSTED_BUTTON_ID_BASIC = 'UXVU9HSN2NWCE';

  const paypalClientId = 'AaHXxh5YE1oofKVdmPtmiyTNSW1Xw-OmFUTHGM6bleuH1gIaXoWuxB1ApI62tAOdJDB03H4SPZUtJdWs';
  const renderPaypalButton = (containerId, planId, setStatus, setError) => {
    try {
      if (!window.paypal) return;
      const container = document.getElementById(containerId);
      if (!container) return;
      if (container.hasChildNodes()) return; // ya renderizado
      setStatus('loading');
      window.paypal.Buttons({
        style: { shape: 'pill', color: 'gold', layout: 'vertical', label: 'subscribe' },
        createSubscription: (data, actions) => {
          setStatus('approving');
          return actions.subscription.create({ plan_id: planId });
        },
        onApprove: (data) => {
          setStatus('approved');
          try {
            const plan = planId === PLAN_PRO_ID ? 'pro' : (planId === PLAN_ENT_ID ? 'enterprise' : 'unknown');
            markPaid('paypal', plan, data?.subscriptionID);
            // Redirigir directo al registro
            window.location.href = '/register';
          } catch (_) {
            alert('Suscripción creada: ' + data.subscriptionID);
          }
        },
        onError: (err) => {
          console.error('[PayPal] error', err);
          setError(String(err?.message || 'Error desconocido'));
          setStatus('error');
        },
        onCancel: () => {
          setError('Proceso cancelado por el usuario');
          setStatus('error');
        }
      }).render(`#${containerId}`).then(() => {
        setStatus('rendered');
      }).catch(e => {
        console.error('[PayPal] render catch', e);
        setError(String(e?.message || 'Fallo al renderizar botón'));
        setStatus('error');
      });
    } catch (e) {
      console.error('[PayPal] excepción', e);
      setError(String(e?.message || 'Excepción inesperada'));
      setStatus('error');
    }
  };
  const renderHostedButton = (containerId, hostedButtonId, setStatus, setError) => {
    try {
      if (!window.paypal || !window.paypal.HostedButtons) return;
      const container = document.getElementById(containerId);
      if (!container) return;
      if (container.hasChildNodes()) return; // ya renderizado
      setStatus('loading');
      window.paypal.HostedButtons({ hostedButtonId })
        .render(`#${containerId}`)
        .then(() => setStatus('rendered'))
        .catch((e) => {
          console.error('[PayPal HostedButtons] render error', e);
          setError(String(e?.message || 'Fallo al renderizar botón'));
          setStatus('error');
        });
    } catch (e) {
      console.error('[PayPal HostedButtons] excepción', e);
      setError(String(e?.message || 'Excepción inesperada'));
      setStatus('error');
    }
  };
  const loadAndRenderPaypal = () => {
    // Básico con Hosted Buttons (solo si no está bloqueado para este dispositivo)
    if (!basicDisabled) {
      renderHostedButton(CID_BASIC, HOSTED_BUTTON_ID_BASIC, setPaypalStatus, setPaypalError);
    }
    renderPaypalButton(CID_PRO,   PLAN_PRO_ID,   setPaypalStatusPro, setPaypalErrorPro);
    renderPaypalButton(CID_ENT,   PLAN_ENT_ID,   setPaypalStatusEnt, setPaypalErrorEnt);
  };

  useEffect(() => {
    // Inicializa el estado de disponibilidad del plan básico (local + backend)
    let disabled = false;
    try { disabled = isBasicBlocked(); } catch (_) {}
    // Si el usuario está autenticado, intentar leer el bloqueo desde el backend y sincronizar
    try {
      api.get('user/profile/').then(({data}) => {
        if (data) {
          const serverDisabled = (data.block_basic === true) || (data.allow_basic === false);
          setBasicDisabled(Boolean(serverDisabled || disabled));
        }
      }).catch(() => {});
    } catch (_) {}
    if (!disabled) setBasicDisabled(false);

    if (paypalLoadedRef.current) { loadAndRenderPaypal(); return; }
    const existing = document.querySelector('script[data-paypal-sdk]');
    if (!existing) {
      const s = document.createElement('script');
      // Cargar SDK una sola vez incluyendo ambos componentes: buttons (Pro/Enterprise) y hosted-buttons (Básico)
      s.src = `https://www.paypal.com/sdk/js?client-id=${paypalClientId}&vault=true&intent=subscription&components=buttons,hosted-buttons&enable-funding=paypal&currency=USD`;
      s.async = true;
      s.dataset.paypalSdk = '1';
      s.onload = () => { paypalLoadedRef.current = true; loadAndRenderPaypal(); };
      s.onerror = () => {
        setPaypalError('No se pudo cargar el SDK de PayPal'); setPaypalStatus('error');
        setPaypalErrorPro('No se pudo cargar el SDK de PayPal'); setPaypalStatusPro('error');
        setPaypalErrorEnt('No se pudo cargar el SDK de PayPal'); setPaypalStatusEnt('error');
      };
      setPaypalStatus('loading'); setPaypalStatusPro('loading'); setPaypalStatusEnt('loading');
      document.head.appendChild(s);
    } else {
      paypalLoadedRef.current = true;
      loadAndRenderPaypal();
    }
  }, [])
  // Timeout defensivo si queda "pensando" más de 60s
  useEffect(() => {
    if (paypalStatus === 'approving' || paypalStatus === 'loading') {
      const t = setTimeout(() => {
        if (paypalStatus === 'approving') {
          setPaypalError('Tiempo excedido esperando respuesta de PayPal. Verifica tu conexión o reintenta.')
          setPaypalStatus('error')
        }
      }, 60000)
      return () => clearTimeout(t)
    }
  }, [paypalStatus])
  return (
    <div>
      {/* Scoped fixes for PayPal Hosted Buttons layout (Básico) */}
      <style>{`
        #paypal-container-UXVU9HSN2NWCE { max-width: 360px; margin: 0 auto; }
        #paypal-container-UXVU9HSN2NWCE *,
        #paypal-container-UXVU9HSN2NWCE button { font-size: 16px; line-height: 1.2; }
        #paypal-container-UXVU9HSN2NWCE form,
        #paypal-container-UXVU9HSN2NWCE .paypal-button,
        #paypal-container-UXVU9HSN2NWCE .paypal-button-layout,
        #paypal-container-UXVU9HSN2NWCE .paypal-buttons,
        #paypal-container-UXVU9HSN2NWCE button { width: 100% !important; }
        #paypal-container-UXVU9HSN2NWCE .paypal-button-layout,
        #paypal-container-UXVU9HSN2NWCE .paypal-button { display: block !important; }
      `}</style>
      {/* HEADER */}
      <header>
        <div className="container header-container">
          {/* LOGO */}
          <div className="logo">
            <img src={logo} alt="WaveSales" />
          </div>

          {/* MENÚ CENTRAL */}
          <nav>
            <ul className="menu">
              <li><Link to="/#inicio" className="active">Inicio</Link></li>
              <li><Link to="/#pricing">Precios</Link></li>
              <li><Link to="/nosotros">Nosotros</Link></li>
              <li><Link to="/#products">Productos</Link></li>
              <li><Link to="/#resources">Recursos</Link></li>
              <li><Link to="/#blog">Blog</Link></li>
            </ul>
          </nav>

          {/* DERECHA: IDIOMA + LOGIN */}
          <div className="header-actions">
            <button
              type="button"
              onClick={toggleTheme}
              className="btn-secondary"
              aria-label="Cambiar tema"
            >
              {theme === "dark" ? "☀️" : "🌙"}
            </button>

            <select className="lang-select" defaultValue="ES">
              <option>ES</option>
              <option>EN</option>
            </select>
            <Link to="/login" className="btn-login">Ingresar</Link>
            <a href="https://ai.wave-sales.com/login" className="btn-login-ai">Ingresar.ai</a>
          </div>

          {/* Toggle móvil */}
          <div className="menu-toggle">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </header>

      {/* HERO */}
      <section className="hero" id="inicio">
        <div className="hero-container">
          <div className="hero-left">
            <h2>Impulsa tus ventas con WaveSales</h2>
            <p>En WaveSales ayudamos a usuarios a conectarse de forma oficial con la API de WhatsApp Business, utilizando la nueva tecnología de Coexistencia de Meta, que permite usar el mismo número de WhatsApp en múltiples plataformas al mismo tiempo en WhatsApp Business App + Soluciones API + CRM, y mas.</p>
            <div className="hero-buttons">
              <Link to="/demo" className="btn-primary">Agendar una Demo</Link>
              <Link to="/register" className="btn-secondary">Crear Cuenta</Link>
            </div>
          </div>

          <div className="hero-right">
            <div className="video-wrapper" style={{ display:'flex', alignItems:'center', justifyContent:'center' }}>
              {/* GIF importado desde src/assets para que Vite genere nombre hasheado y evitemos caché */}
              <img
                src={landingGif}
                alt="Presentación WaveSales"
                style={{
                  width: '100%',
                  height: 'auto',
                  maxWidth: 560,
                  borderRadius: 12,
                  boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* BENEFICIOS */}
      <section className="benefits">
        <div className="container">
          <h2 className="benefits-title">Conoce los beneficios que te ofrece WaveSales</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-img">
                <img src={beneficio1} alt="Organiza tus chats" />
              </div>
              <h3>Organiza tus chats</h3>
              <p>Organiza tus chats en columnas personalizadas para dar seguimiento efectivo desde el primer mensaje hasta el cierre de la venta.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-img">
                <img src={beneficio2} alt="Personaliza tu atención" />
              </div>
              <h3>Personaliza tu atención</h3>
              <p>Configura respuestas rápidas, mensajes de bienvenida y flujos automáticos para atender a tus clientes incluso fuera de horario.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-img">
                <img src={beneficio3} alt="Programa mensajes" />
              </div>
              <h3>Programa mensajes</h3>
              <p>Programa mensajes automáticos para mantener comunicación constante con tus clientes en el momento justo.</p>
            </div>
          </div>

          <div className="benefits-btn">
            <Link to="/demo" className="btn-primary">Agendar una demo 📅</Link>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" className="pricing">
        <div className="container">
          <h2>Planes y Precios</h2>
          <div className="pricing-grid" style={{ justifyContent:'center', alignItems:'stretch' }}>
            <div className="pricing-card" style={{ display: 'flex', flexDirection: 'column', alignItems:'stretch' }}>
              <h3>Plan Básico</h3>
              <p>$7/7días</p>
              <ul>
                <li>Leads ilimitados</li>
                <li>Automatización avanzada</li>
                <li>Soporte por email</li>
              </ul>
              {/* Botón de registro eliminado: reemplazado por PayPal */}
              {/* Contenedor PayPal al fondo + estado */}
              <div style={{ marginTop:'auto', width:'100%', display:'flex', flexDirection:'column', alignItems:'center', paddingTop:12, minHeight:120 }}>
                {basicDisabled ? (
                  <div style={{ textAlign:'center', fontSize:14, color:'#64748b' }}>
                    Este plan ya no está disponible para tu cuenta.
                    <br />
                    Renueva tu acceso desde <a href="/renovacion" style={{ color:'#0ea5e9', textDecoration:'underline' }}>Renovación</a> o elige un plan superior.
                  </div>
                ) : (
                  <>
                    <div
                      id="paypal-container-UXVU9HSN2NWCE"
                      style={{
                        minHeight: 50,
                        display: 'block',
                        textAlign: 'center',
                        maxWidth: 360,
                        width: '100%'
                      }}
                    />
                    {paypalStatus !== 'approved' && (
                      <div style={{ marginTop: 8, fontSize:12, textAlign:'center', color: paypalStatus === 'error' ? '#b91c1c' : '#475569' }}>
                        {paypalStatus === 'idle' && 'Preparando botón de pago…'}
                        {paypalStatus === 'loading' && 'Cargando PayPal…'}
                        {paypalStatus === 'rendered' && 'Listo para pagar.'}
                        {paypalStatus === 'error' && (
                          <>
                            Error: {paypalError || 'Fallo inesperado.'} <br />
                            <button type="button" onClick={() => { setPaypalStatus('idle'); setPaypalError(''); loadAndRenderPaypal(); }} style={{ marginTop:6, background:'#0ea5e9', color:'#fff', border:'none', borderRadius:6, padding:'6px 12px', cursor:'pointer' }}>Reintentar</button>
                          </>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="pricing-card featured" style={{ display:'flex', flexDirection:'column', alignItems:'stretch' }}>
              <h3>Plan Pro</h3>
              <p>$29/mes</p>
              <ul>
                <li>Leads ilimitados</li>
                <li>Automatización avanzada</li>
                <li>Soporte prioritario</li>
              </ul>
              {/* Botón de registro eliminado: reemplazado por PayPal */}
              <div style={{ marginTop:'auto', width:'100%', display:'flex', flexDirection:'column', alignItems:'center', paddingTop:12, minHeight:120 }}>
                <div id="paypal-button-container-P-0AL74437SD0607350NEKAA2A" style={{ minHeight:50, width:'100%', display:'flex', justifyContent:'center' }} />
                {paypalStatusPro !== 'approved' && (
                  <div style={{ marginTop: 8, fontSize:12, textAlign:'center', color: paypalStatusPro === 'error' ? '#b91c1c' : '#475569' }}>
                    {paypalStatusPro === 'idle' && 'Preparando botón de suscripción…'}
                    {paypalStatusPro === 'loading' && 'Cargando PayPal…'}
                    {paypalStatusPro === 'rendered' && 'Listo para suscribirte.'}
                    {paypalStatusPro === 'approving' && 'Procesando suscripción…'}
                    {paypalStatusPro === 'error' && (
                      <>
                        Error: {paypalErrorPro || 'Fallo inesperado.'} <br />
                        <button type="button" onClick={() => { setPaypalStatusPro('idle'); setPaypalErrorPro(''); loadAndRenderPaypal(); }} style={{ marginTop:6, background:'#0ea5e9', color:'#fff', border:'none', borderRadius:6, padding:'6px 12px', cursor:'pointer' }}>Reintentar</button>
                      </>
                    )}
                  </div>
                )}
                {paypalStatusPro === 'approved' && (
                  <div style={{ marginTop:8, fontSize:12, color:'#0f766e' }}>Suscripción creada correctamente ✅</div>
                )}
              </div>
            </div>
            <div className="pricing-card" style={{ display:'flex', flexDirection:'column', alignItems:'stretch' }}>
              <h3>Plan Enterprise</h3>
              <p>$69/trimestral</p>
              <ul>
                <li>Todo incluido</li>
                <li>Automatización avanzada</li>
                <li>Soporte 24/7</li>
              </ul>
              {/* Botón de registro eliminado: reemplazado por PayPal */}
              <div style={{ marginTop:'auto', width:'100%', display:'flex', flexDirection:'column', alignItems:'center', paddingTop:12, minHeight:120 }}>
                <div id="paypal-button-container-P-22615101DU119082JNEKABSI" style={{ minHeight:50, width:'100%', display:'flex', justifyContent:'center' }} />
                {paypalStatusEnt !== 'approved' && (
                  <div style={{ marginTop: 8, fontSize:12, textAlign:'center', color: paypalStatusEnt === 'error' ? '#b91c1c' : '#475569' }}>
                    {paypalStatusEnt === 'idle' && 'Preparando botón de suscripción…'}
                    {paypalStatusEnt === 'loading' && 'Cargando PayPal…'}
                    {paypalStatusEnt === 'rendered' && 'Listo para suscribirte.'}
                    {paypalStatusEnt === 'approving' && 'Procesando suscripción…'}
                    {paypalStatusEnt === 'error' && (
                      <>
                        Error: {paypalErrorEnt || 'Fallo inesperado.'} <br />
                        <button type="button" onClick={() => { setPaypalStatusEnt('idle'); setPaypalErrorEnt(''); loadAndRenderPaypal(); }} style={{ marginTop:6, background:'#0ea5e9', color:'#fff', border:'none', borderRadius:6, padding:'6px 12px', cursor:'pointer' }}>Reintentar</button>
                      </>
                    )}
                  </div>
                )}
                {paypalStatusEnt === 'approved' && (
                  <div style={{ marginTop:8, fontSize:12, color:'#0f766e' }}>Suscripción creada correctamente ✅</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SIGNUP eliminado: el registro ahora se realiza en /register */}

      {/* FOOTER */}
      <footer className="bg-gray-900 dark:bg-gray-950 text-gray-300 py-10 border-t border-gray-700 mt-16">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Logo y descripción */}
        <div>
          <h2 className="text-2xl font-bold text-white mb-3">WaveSales</h2>
          <p className="text-gray-400 text-sm leading-relaxed">
            Potencia tus ventas con nuestras soluciones digitales. 
            Simplifica la gestión y mejora tus resultados.
          </p>
        </div>

        {/* Información de contacto */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-3">Contáctanos</h3>
          <ul className="space-y-2 text-gray-400 text-sm">
            <li>
              📞 Teléfono:<span className="ml-1">+593 959 163 654</span>
            </li>
            <li>
              📧 Correo:<a href="mailto:contacto@wave-sales.com" className="hover:text-indigo-400 transition">
                contacto@wave-sales.com
              </a>
            </li>
            <li>
              📍 Dirección:<span className="ml-1">Santa Lucia y De Los Helechos.</span>
            </li>
            <li>Quito - Ecuador </li> 
            <li>🏷️ Código Postal: 170139</li>
          </ul>
        </div>

        {/* Enlaces rápidos */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-3">Enlaces rápidos</h3>
          <ul className="space-y-2 text-gray-400 text-sm">
            <li><a href="#inicio" className="hover:text-indigo-400 transition">Inicio</a></li>
            <li><a href="#servicios" className="hover:text-indigo-400 transition">Precios</a></li>
            <li><a href="#beneficios" className="hover:text-indigo-400 transition">Nosotros</a></li>
            <li><a href="#contacto" className="hover:text-indigo-400 transition">Productos</a></li>
          </ul>
        </div>
      </div>

      {/* Políticas y términos */}
      <div className="border-t border-gray-700 mt-10 pt-6 text-center">
        <div className="flex flex-wrap items-center justify-center gap-4 text-gray-400 text-sm mb-4">
          <Link to="/terminos-y-condiciones" className="hover:text-indigo-400 transition">
            Términos y condiciones
          </Link>
          <span className="text-gray-600">•</span>
          <Link to="/politica-de-privacidad" className="hover:text-indigo-400 transition">
            Política de privacidad
          </Link>
          <span className="text-gray-600">•</span>
          <Link to="/politica-de-cookies" className="hover:text-indigo-400 transition">
            Política de Cookies
          </Link>
        </div>
        <p className="text-gray-500 text-sm">
          &copy; 2025 <span className="text-indigo-400 font-semibold">WaveSales</span>. Todos los derechos reservados.
        </p>
      </div>
    </footer>


      {/* Widget de WhatsApp solo en la landing */}
      <FloatingWhatsApp />
    </div>
  )
}

export default WaveSalesLanding
